import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static debounces = ["fetchPOs"];
  static targets = ["PoSearchInput", "PoDropdown", "PoList"];
  static values = {
    handlingController: String,
  };

  connect() {
    this.element[this.identifier] = this;
    useDebounce(this);

    this.PoSearchInputTarget.addEventListener("input", (e) => {
      this.fetchPOs(e.target.value);
    });

    this.PoListTarget.addEventListener("click", (e) => {
      if (e.target.tagName === "LI") {
        const poData = JSON.parse(decodeURIComponent(escape(atob(e.target.getAttribute("data-po")))));
        this.handlePoSelect(poData);
        this.PoDropdownTarget.classList.add("hidden");
      }
    });
  }

  onKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  async fetchPOs(search) {
    const response = await fetch(`/admin/purchase_orders/search?query=${search}`, {
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    this.updatePoDropdown(data);
  }

  updatePoDropdown(pos) {
    console.log("pos", pos);
    this.PoListTarget.innerHTML = pos.map((po) => `<li class="p-2 cursor-pointer hover:bg-gray-200" data-id="${po.id}" data-po='${btoa(unescape(encodeURIComponent(JSON.stringify(po))))}'>${po.id} - ${po.number} - ${po.customer_name}</li>`).join("");
    if (pos.length > 0) {
      this.PoDropdownTarget.classList.remove("hidden");
    } else {
      this.PoDropdownTarget.classList.add("hidden");
    }
  }

  handlePoSelect(po) {
    if (this.hasHandlingControllerValue) {
      let controller;
      for (const ctrl of this.application.controllers) {
        if (ctrl.identifier === this.handlingControllerValue) {
          const controllerIdentifiers = ctrl.element.getAttribute("data-controller").split(" ");
          if (controllerIdentifiers.includes(this.handlingControllerValue)) {
            controller = ctrl;
            console.log(controller);
            break; // If you want to stop after finding the first match
          }
        }
      }
      if (controller) {
        controller.handlePoSelect(po);
      } else {
        console.log("Controller not found");
      }
    } else {
      console.log("po: ", po);
      if (po.order) {
        if (this.hasCustomerNameInputTarget) {
          this.CustomerNameInputTarget.value = po.order.shipping_name;
        }
        if (this.hasCustomerCompanyInputTarget) {
          this.CustomerCompanyInputTarget.value = po.order.company_name;
        }
        if (this.hasCustomerEmailInputTarget) {
          this.CustomerEmailInputTarget.value = po.order.email;
        }
        if (this.hasCustomerPhoneInputTarget) {
          this.CustomerPhoneInputTarget.value = po.order.phone_number;
        }
        if (this.hasCustomerStreetInputTarget) {
          this.CustomerStreetInputTarget.value = po.order.shipping_address;
        }
        if (this.hasCustomerCityInputTarget) {
          this.CustomerCityInputTarget.value = po.order.shipping_city;
        }
        if (this.hasCustomerStateInputTarget) {
          this.CustomerStateInputTarget.value = po.order.shipping_state;
        }
        if (this.hasCustomerZipInputTarget) {
          this.CustomerZipInputTarget.value = po.order.shipping_zipcode;
        }
      }
      if (this.hasPurchaseOrderIdInputTarget) {
        this.PurchaseOrderIdInputTarget.value = po.id;
      }
    }
  }
}
